import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpUtilsService, QueryParamsModel, QueryResultsModel } from '../../_base/crud';
import { Reason } from '../_models/reason.model';
import { select, Store } from '@ngrx/store';
import { AppState } from '../../reducers';
import { currentAuthToken, currentUser } from '../../auth';
import { environment } from 'src/environments/environment';

@Injectable()
export class CategoryDescriptionService {
  private authToken;
  private company_id;

  constructor(
    private http: HttpClient,
    private httpUtils: HttpUtilsService,
    private store: Store<AppState>,
  ) {
    this.store.pipe(select(currentAuthToken)).subscribe((res) => (this.authToken = res));
    this.store.pipe(select(currentUser)).subscribe((res) => (this.company_id = res.companyID));
  }

  createCategoryDescription(item) {
    const url = `${environment.CORE_BASE}/companies/${this.company_id}/relation_types/types`;
    const headers = this.httpUtils.getHTTPHeaders(this.authToken);
    return this.http.post<Reason>(url, item, { headers });
  }

  findCategoryDescription(queryParams: QueryParamsModel): Observable<any> {
    const url = `${environment.CORE_BASE}/companies/${this.company_id}/relation_types/types`;
    const params = new HttpParams({
      fromString: CategoryDescriptionService.getCategoryDescriptionListQueryString(queryParams),
    });
    return this.http.get<QueryResultsModel>(url, { params });
  }

  private static getCategoryDescriptionListQueryString(queryParams: QueryParamsModel): string {
    const { pageNumber, pageSize, sortField, sortOrder, filter } = queryParams;
    let fromString = `page=${pageNumber}&size=${pageSize}&sort=${sortField},${sortOrder}`;

    if (filter.searchTerm) {
      fromString += `&term=${filter.searchTerm}`;
    } else {
      if (filter.category) fromString += `&category_has=${filter.category}`;
      if (filter.type) fromString += `&type_has=${filter.type}`;
      if (filter.description) fromString += `&description_has=${filter.description}`;
    }
    return fromString;
  }
  updateCategoryDescription(item): Observable<any> {
    const url = `${environment.CORE_BASE}/companies/${this.company_id}/relation_types/types/${item.id}`;
    return this.http.put<Reason>(url, item);
  }

  deleteCategoryDescription(itemId: number): Observable<any> {
    const url = `${environment.CORE_BASE}/companies/${this.company_id}/relation_types/types/${itemId}`;
    return this.http.delete<any>(url);
  }
}
